import { Column } from 'src/shared/components/Semantic/all'
import { LogosSection } from './components/LogosSection'
import { ProofsSections } from './components/ProofsSections'
import { VectorizedLogos } from './components/VectorizedLogos'

export const Assets = () => {
  return (
    <Column className="gap-6">
      <VectorizedLogos />
      <ProofsSections />
      <LogosSection />
    </Column>
  )
}
